import ZipCodeMask from './ZipCodeMask';
import DateMask from './DateMask';
import PhoneMask from './PhoneMask';
import CPFMask from './CPFMask';
import CNPJMask from './CNPJMask';
import MoneyMask from './MoneyMask';
import CreditCardNumberMask from './CreditCardNumberMask';
import CreditCardExpirationDateMask from './CreditCardExpirationDateMask';
import CreditCardCvvMask from './CreditCardCvvMask';
import NumberMask from './NumberMask';
import PercentMask from './PercentMask';

export { DateMask };
export { PhoneMask };
export { CPFMask };
export { CNPJMask };
export { ZipCodeMask };
export { MoneyMask };
export { CreditCardNumberMask };
export { CreditCardExpirationDateMask };
export { CreditCardCvvMask };
export { NumberMask };
export { PercentMask };

export type MaskProps = {
  mask?:
    | 'date'
    | 'phone'
    | 'cpf'
    | 'cnpj'
    | 'zipcode'
    | 'money'
    | 'creditCardNumber'
    | 'creditCardExpirationDate'
    | 'creditCardCvv'
    | 'number'
    | 'percent';
};

export const Masks = {
  cpf: CPFMask,
  cnpj: CNPJMask,
  date: DateMask,
  phone: PhoneMask,
  zipcode: ZipCodeMask,
  money: MoneyMask,
  creditCardNumber: CreditCardNumberMask,
  creditCardExpirationDate: CreditCardExpirationDateMask,
  creditCardCvv: CreditCardCvvMask,
  number: NumberMask,
  percent: PercentMask,
};
